module.exports = false;



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_library.js